"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateGasDeclaration = exports.EstimateGasResponse = exports.EstimateGasRequest = void 0;
const endpoints_1 = require("@moojo/endpoints");
const zod_1 = require("zod");
const hex_big_int_1 = require("./hex-big-int");
const relayed_transaction_1 = require("./relayed-transaction");
exports.EstimateGasRequest = zod_1.z.object({
    transaction: relayed_transaction_1.RelayedTransaction,
    // TODO: consider passing ABI of called contract.
});
exports.EstimateGasResponse = zod_1.z.object({
    gas: hex_big_int_1.HexBigInt,
});
exports.estimateGasDeclaration = (0, endpoints_1.endpointDeclaration)(exports.EstimateGasRequest, exports.EstimateGasResponse);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXN0aW1hdGUtZ2FzLWFwaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lc3RpbWF0ZS1nYXMtYXBpLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGdEQUFzRDtBQUN0RCw2QkFBdUI7QUFFdkIsK0NBQXlDO0FBQ3pDLCtEQUEwRDtBQUU3QyxRQUFBLGtCQUFrQixHQUFHLE9BQUMsQ0FBQyxNQUFNLENBQUM7SUFDekMsV0FBVyxFQUFFLHdDQUFrQjtJQUMvQixpREFBaUQ7Q0FDbEQsQ0FBQyxDQUFBO0FBR1csUUFBQSxtQkFBbUIsR0FBRyxPQUFDLENBQUMsTUFBTSxDQUFDO0lBQzFDLEdBQUcsRUFBRSx1QkFBUztDQUNmLENBQUMsQ0FBQTtBQUlXLFFBQUEsc0JBQXNCLEdBQUcsSUFBQSwrQkFBbUIsRUFBQywwQkFBa0IsRUFBRSwyQkFBbUIsQ0FBQyxDQUFBIn0=